import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { EMAIL_LOGIN_ACTION_TYPE } from "./email-login.action";
import { EmailLoginState } from "./email-login.model";

const INITIAL_STATE = {
	email: undefined,
};

export function emailLoginReducer(state = INITIAL_STATE, action: ActionWithPayload): EmailLoginState {
	switch (action.type) {
		case EMAIL_LOGIN_ACTION_TYPE.setEmailLogin: {
			return updateState(state, {
				email: action.payload,
			});
		}
		default: {
			return state;
		}
	}
}
